var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"bubble-flex-preview-container"},[_c('div',{staticClass:"single-bubble-flex-container",domProps:{"innerHTML":_vm._s(_vm.renderedBubbleFlex)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }